import axios from "axios";
import { getURLPrefix } from "./getUrlPrefix";

const URL_PREFIX = getURLPrefix();

async function uploadAsset(assetName, file, type, cb) {
  const data = new FormData();
  data.append("name", assetName);
  data.append("type", type);
  let assetId = "";
  axios
    .post(URL_PREFIX + "/creatives/media/assets?upload=true", data)
    .then((res) => {
      assetId = res.data.asset_id;
      const assetSrcUrl = res.data.url;
      if (assetId && assetSrcUrl) {
        const instance = axios.create();
        delete instance.defaults.headers.Authorization;
        // delete instance.defaults.headers.common['Content-Type'];
        instance
          .put(assetSrcUrl, file, {
            onUploadProgress: () => {},
            headers: {
              "Content-Type": "",
            },
          })
          .then(() => {
            if (cb) {
              cb(assetId);
            }
          })
          .catch(() => {
            assetId = ""; // set it to blank to indicate failure
            cb?.("");
          });
      } else if (cb) {
        cb("");
      }
    })
    .catch(() => {
      assetId = ""; // set it to blank to indicate failure
      cb?.("");
    });
}

async function getAssetSrcUrl(assetId, cb) {
  let assetSrcUrl = "";
  await axios.get(URL_PREFIX + "/creatives/media/assets?id=" + assetId).then((res) => {
    assetSrcUrl = res.data["url"];
  });

  cb?.(assetSrcUrl);
}

export { uploadAsset, getAssetSrcUrl };
